/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
// export const onClientEntry = () => {
//     // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
//     if (!(`IntersectionObserver` in window)) {
//       import(`intersection-observer`);
//     }
//   };
import React from 'react';
// import { I18nextProvider } from 'react-i18next';

import './src/translation/i18n';
import { LocationContext } from './src/contexts/LocationContext';

export const wrapPageElement = ({ element, props }) => {
  return (
    /* <I18nextProvider i18n={i18n}> */
    <LocationContext.Provider value={props.location}>{element}</LocationContext.Provider>
    /* </I18nextProvider> */
  );
};

export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!(`IntersectionObserver` in window)) {
    import(`intersection-observer`);
  }
};
